<template>
  <v-container class="container-layout">
    <template
      v-if="manifests && manifests.length > 0"
    >
      <div
        v-for="(manifest, index) in manifests"
        :key="manifest.id"
      >
        <div class="manifest">
          <h2></h2>
          <v-row>
            <v-col cols="12">
              <div class="table_line">
                <div class="block" style="width: 60%;">
                  <h1 class="text-right">
                    受渡確認票
                  </h1>
                </div>
                <div class="block" style="width: 40%;">
                  <v-img
                    max-height="180"
                    max-width="180"
                    contain
                    style="margin-left: auto;"
                    :src="require(`@/assets/images/DXEstation_logo_RGB.png`)"
                  />
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- マニフェスト番号／引渡し日／引渡担当者 -->
          <v-row dense>
            <v-col
              cols="12"
            >
              <div class="table" style="width: 204mm">
                <div class="table_line">
                  <!-- マニフェスト番号 -->
                  <div class="block bordered label" style="width: 55mm;">
                    マニフェスト番号
                  </div>
                  <div class="block bordered" style="width: 35mm;">
                    <span>&nbsp;{{ manifest.manifest_no }}</span>
                  </div>
                  <!-- /マニフェスト番号 -->

                  <!-- 引渡日 -->
                  <div class="block bordered label" style="width: 28mm;font-size: 70%">
                    引渡日（積載日）
                  </div>
                  <div class="block bordered" style="width: 27mm;">
                    <span>&nbsp;{{ manifest.collected_date | date_format }}</span>
                  </div>
                  <!-- /引渡日 -->

                  <!-- 引渡担当者 -->
                  <div class="block bordered label" style="width: 24mm;font-size: 70%">
                    引渡担当者
                  </div>
                  <div class="block bordered" style="width: 35mm;">
                    <span>&nbsp;{{ manifest.deliver_staff }}</span>
                  </div>
                  <!-- /引渡担当者 -->
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /マニフェスト番号／引渡し日／引渡担当者 -->

          <!-- 排出事業者／排出事業場 -->
          <v-row dense>
            <v-col
              cols="12"
            >
              <div class="table" style="width: 204mm">
                <div class="table_line">
                  <div class="block bordered label" style="width: 30mm;">
                    排出事業者
                  </div>
                  <div class="block" style="width: 174mm;">
                    <div>
                      <!-- 名称 -->
                      <div class="table_line">
                        <div class="block label bordered" style="width: 25mm;">
                          名称
                        </div>
                        <div class="block bordered" style="width: 149mm;">
                          <span>&nbsp;{{ manifest.supplier_name }}</span>
                        </div>
                      </div>
                      <!-- /名称 -->
                      <!-- 住所 -->
                      <div class="table_line">
                        <div class="block label bordered" style="width: 25mm;">
                          住所
                        </div>
                        <div class="block bordered" style="width: 149mm;">
                          &nbsp;<span v-if="manifest.supplier_zip_code">〒{{manifest.supplier_zip_code}}</span>
                          <span>&nbsp;{{ manifest.supplier_address }}</span>
                        </div>
                      </div>
                      <!-- /住所 -->
                      <!-- 電話番号／加入者番号 -->
                      <div class="table_line">
                        <div class="block label bordered" style="width: 25mm;">
                          電話番号
                        </div>
                        <div class="block bordered" style="width: 35mm;">
                          <span>&nbsp;{{ manifest.supplier_phone_number }}</span>
                        </div>
                        <div class="block label bordered" style="width: 28mm;">
                          加入者番号
                        </div>
                        <div class="block bordered" style="width: 86mm;">
                          <span>&nbsp;{{ manifest.supplier_subscriber_number }}</span>
                        </div>
                      </div>
                      <!-- /電話番号／加入者番号 -->
                    </div>
                  </div>
                </div>

                <div class="table_line">
                  <div class="block bordered label" style="width: 30mm;">
                    排出事業場
                  </div>
                  <div class="block" style="width: 174mm;">
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        名称
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        <span>&nbsp;{{ manifest.supplier_location_name }}</span>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        住所
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        &nbsp;<span v-if="manifest.supplier_location_zip_code">〒{{manifest.supplier_location_zip_code}}</span>
                        <span>&nbsp;{{ manifest.supplier_location_address }}</span>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        電話番号
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        <span>&nbsp;{{ manifest.supplier_location_phone_number }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /排出事業者／排出事業場 -->

          <!-- 産業廃棄物 -->
          <v-row dense>
            <v-col
              cols="12"
            >
              <div class="table" style="width: 204mm">
                <div class="table_line">
                  <div class="block bordered label" style="width: 30mm;">
                    産業廃棄物
                  </div>

                  <div class="block" style="width: 174mm;">
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        種類
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        <span style="font-size: 85%">&nbsp;{{ manifest.item_name }}</span>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block" style="width: 114mm">
                        <div class="table_line">
                          <div class="block label bordered" style="width: 25mm;">
                            数量
                          </div>
                          <div class="block bordered" style="width: 35mm;">
                            <span>&nbsp;{{ manifest.quantity }}</span>
                          </div>
                          <div class="block label bordered" style="width: 28mm;">
                            確定数量
                          </div>
                          <div class="block bordered" style="width: 86mm;">
                            <span>&nbsp;{{ manifest.fixed_quantity }}</span>
                          </div>
                        </div>
                        <div class="table_line">
                          <div class="block label bordered" style="width: 25mm;">
                            荷姿
                          </div>
                          <div class="block bordered" style="width: 35mm;">
                            <p>&nbsp;{{ manifest.packing_name }}&emsp;{{ manifest.packing_quantity }}</p>
                          </div>
                          <div class="block label bordered" style="width: 28mm;">
                            数量の確定者
                          </div>
                          <div class="block bordered" style="width: 86mm;">
                            <span>&nbsp;{{ manifest.quantity_confirm_name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        有害物質
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        <p
                          v-if="manifest.hazardous_substance_name"
                          class="hazardous_substance"
                        >
                          &nbsp;{{ manifest.hazardous_substance_name }}
                        </p>
                        <template v-if="['specific_industrial','specific_special_industrial'].includes(manifest.waste_type)">
                          <span class="ml-n1">【放射能濃度】データなし、【表面線量率】データなし</span>
                        </template>
                        <template v-else>
                          <span>&nbsp;放射性物質対象外</span>
                        </template>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block label bordered" style="width: 35mm;">
                        廃棄物の名称
                      </div>
                      <div class="block bordered" style="width: 139mm;">
                        <span>&nbsp;{{ manifest.waste_name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /産業廃棄物 -->

          <!-- 収集運搬業者区間 -->
          <v-row dense>
            <v-col
              cols="12"
            >
              <div class="table" style="width: 204mm">
                <div class="table_line">
                  <div class="block label bordered" style="width: 30mm;">
                    収集運搬業者<br>区間{{ manifest.section_no }}
                  </div>
                  <div class="block" style="width: 174mm;">
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        名称
                      </div>
                      <div class="block bordered" style="width: 85mm;">
                        <span>&nbsp;{{ manifest.transport_name }}</span>
                      </div>
                      <div class="block label bordered" style="width: 29mm;">
                        車両番号（排出）
                      </div>
                      <div class="block bordered" style="width: 35mm;">
                        <span>&nbsp;{{ manifest.transport_vehicle_number }}</span>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        住所
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        &nbsp;<span v-if="manifest.transport_zip_code">〒{{manifest.transport_zip_code}}</span>
                        <span>&nbsp;{{ manifest.transport_address }}</span>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        電話番号
                      </div>
                      <div class="block bordered" style="width: 35mm;">
                        <span>&nbsp;{{ manifest.transport_phone_number }}</span>
                      </div>
                      <div class="block label bordered" style="width: 25mm;">
                        加入者番号
                      </div>
                      <div class="block bordered" style="width: 25mm;">
                        <span>&nbsp;{{ manifest.transport_subscriber_number }}</span>
                      </div>
                      <div class="block label bordered" style="width: 29mm;">
                        許可番号
                      </div>
                      <div class="block bordered" style="width: 35mm;">
                        <span>&nbsp;{{ manifest.transport_permit_number }}</span>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        運搬担当者
                      </div>
                      <div class="block bordered" style="width: 85mm;">
                        <span>&nbsp;{{ manifest.transport_staff }}</span>
                      </div>
                      <div class="block label bordered" style="width: 29mm;">
                        車両番号（収運）
                      </div>
                      <div class="block bordered" style="width: 35mm;">
                        <span>&nbsp;{{ manifest.transport_report_vehicle_number }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /収集運搬業者区間 -->

          <!-- 運搬先の事業場 -->
          <v-row dense>
            <v-col
              cols="12"
            >
              <div class="table" style="width: 204mm">
                <div class="table_line">
                  <div class="block label bordered" style="width: 30mm;">
                    運搬先の事業場
                  </div>
                  <div class="block" style="width: 174mm;">
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        名称
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        <span>&nbsp;{{ manifest.trader_location_name }}</span>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        住所
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        &nbsp;<span v-if="manifest.trader_location_zip_code">〒{{manifest.trader_location_zip_code}}</span>
                        <span>&nbsp;{{ manifest.trader_location_address }}</span>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        電話番号
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        <span>&nbsp;{{ manifest.trader_location_phone_number }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /運搬先の事業場 -->

          <!-- 処分事業場 -->
          <v-row dense>
            <v-col
              cols="12"
            >
              <div class="table" style="width: 204mm">
                <div class="block label bordered" style="width: 30mm;">
                  処分事業者
                </div>
                <div class="block" style="width: 174mm;">
                  <div class="table_line">
                    <div class="block label bordered" style="width: 25mm;">
                      名称
                    </div>
                    <div class="block bordered" style="width: 149mm;">
                      <span>&nbsp;{{ manifest.disposal_name }}</span>
                    </div>
                  </div>
                </div>
                <div class="table_line">
                  <div class="block label bordered" style="width: 30mm;">
                    処分事業場
                  </div>
                  <div class="block" style="width: 174mm;">
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        名称
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        <span>&nbsp;{{ manifest.disposal_location_name }}</span>
                      </div>
                    </div>

                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        住所
                      </div>
                      <div class="block bordered" style="width: 149mm;">
                        &nbsp;<span v-if="manifest.disposal_location_zip_code">〒{{manifest.disposal_location_zip_code}}</span>
                        <span>&nbsp;{{ manifest.disposal_location_address }}</span>
                      </div>
                    </div>
                    <div class="table_line">
                      <div class="block label bordered" style="width: 25mm;">
                        電話番号
                      </div>
                      <div class="block bordered" style="width: 35mm;">
                        <span>&nbsp;{{ manifest.disposal_location_phone_number }}</span>
                      </div>
                      <div class="block label bordered" style="width: 28mm;">
                        加入者番号
                      </div>
                      <div class="block bordered" style="width: 27mm;">
                        <span>&nbsp;{{ manifest.disposal_subscriber_number }}</span>
                      </div>
                      <div class="block label bordered" style="width: 24mm;">
                        許可番号
                      </div>
                      <div class="block bordered" style="width: 35mm;">
                        <span>&nbsp;{{ manifest.disposal_permit_number }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /処分事業場 -->

          <!-- 備考1〜5 -->
          <v-row dense>
            <v-col
              cols="12"
            >
              <div class="table" style="width: 204mm">
                <div class="table_line">
                  <div class="block bordered label" style="width: 30mm;">
                    備考1
                  </div>
                  <div class="block bordered" style="width: 72mm;">
                    <span style="font-size: 60%">&nbsp;{{ manifest.note_1 }}</span>
                  </div>
                  <div class="block bordered label" style="width: 30mm;">
                    備考2
                  </div>
                  <div class="block bordered" style="width: 72mm;">
                    <span style="font-size: 60%">&nbsp;{{ manifest.note_2 }}</span>
                  </div>
                </div>
                <div class="table_line">
                  <div class="block bordered label" style="width: 30mm;">
                    備考3
                  </div>
                  <div class="block bordered" style="width: 72mm;">
                    <span style="font-size: 60%">&nbsp;{{ manifest.note_3 }}</span>
                  </div>
                  <div class="block bordered label" style="width: 30mm;">
                    備考4
                  </div>
                  <div class="block bordered" style="width: 72mm;">
                    <span style="font-size: 60%">&nbsp;{{ manifest.note_4 }}</span>
                  </div>
                </div>
                <div class="table_line" style="width: 102mm">
                  <div class="block bordered label" style="width: 30mm;">
                    備考5
                  </div>
                  <div class="block bordered" style="width: 72mm;">
                    <span style="font-size: 60%">&nbsp;{{ manifest.note_5 }}</span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /備考1〜5 -->

          <!-- 備考 -->
          <v-row dense>
            <v-col
              cols="12"
            >
              <div class="table" style="width: 204mm">
                <div class="table_line">
                  <div class="block label bordered" style="width: 30mm;height: 15mm;">
                    通信欄
                  </div>
                  <div class="block bordered" style="width: 174mm;height: 15mm;">
                    &nbsp;
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- 備考 -->

          <!-- 印刷日時 -->
          <v-row dense>
            <v-col cols="12">
              <div class="table" style="width: 204mm;border: none;">
                <div class="table_line">
                  <div class="block" style="width: 100mm;">
                  </div>
                  <div class="block" style="width: 100mm;">
                    <div style="width: 100%;border-bottom: #999 1px solid">
                      印刷日時:<span class="float-right" style="font-size: 100%">{{ systemTime }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /印刷日時 -->
        </div>
        <hr v-if="(index+1) < manifests.length" class="print-break" />
      </div>
    </template>
    <template
      v-else-if="manifests && manifests.length <= 0"
    >
      <h2 class="text-center">
        出力可能な受注がありません。
      </h2>
    </template>
  </v-container>

</template>

<script>
export default {
  name: "ConfirmationSlipTemplate",
  components: {},
  mixins: [],
  props: {
    manifests: {
      type: Array,
      default: () => null
    }
  },
  data() {
    return {
      systemTime: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.systemTime = this.$dayjs().format("YYYY/MM/DD HH:mm")
  },
  methods: {}
}
</script>

<style scoped lang="scss">
body {
  overflow-y: scroll;
  height: auto;
}
.container-layout {
  border: solid 1px #ddd;
  background-color: #fff;
  & .manifest {
    width: 210mm;
    height:300mm;
    margin: 0 auto;
  }
}
.table {
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  width: 204mm;
}

.table_line {
  display: table;
  width: 100%;
  height: 7mm;
}

.block {
  display: table-cell;
  vertical-align: initial;
  color: #000;
  &.label {
    background-color: #dddddd;
    text-align: center;
    font-size: 70%;
  }
  &.bordered {
    border-right: solid 1px #999;
    border-bottom: solid 1px #999;
  }
  & span {
    font-size: 75%;
    vertical-align: center;
  }
  & p {
    font-size: 60%;
    margin-bottom: 0;
  }

}

hr {
  page-break-after: always;
}
@media print {
  .container-layout {
    border: none;
  }
  .print-break {
    page-break-after: always;
    border: none;
  }
}
</style>
